// extracted by mini-css-extract-plugin
export var container = "navigation-module--container--133f4";
export var logo = "navigation-module--logo--be047";
export var logoLink = "navigation-module--logoLink--0ea2e";
export var navigation = "navigation-module--navigation--92a8b";
export var navigationItem = "navigation-module--navigationItem--d3edd";